import React, { useEffect } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { Container } from "reactstrap";
import ConfigView from "./components/ViewIssuerConfig";
import PageHeader from "../../../shared/components/PageHeader";
import { viewIssuerConfig } from "../actions/issuerConfig.actions";

const ViewIssuerConfig = props => {
  const { dispatch, config } = props

  function fetchConfig() {
    dispatch(viewIssuerConfig(props.match.params.id, props.match.params.issuerCode));
  }

  useEffect(() => {
    if (props.match.params.id && props.match.params.issuerCode) {
      dispatch(viewIssuerConfig(props.match.params.id, props.match.params.issuerCode));
    }
  }, [dispatch, props.match.params.id, props.match.params.issuerCode]);

  return (
    <Container>
      <PageHeader
        header="View Configuration"
        subheader="View issuer card configuration"
      />

      <ConfigView
        configId={props.match.params.id}
        config={config}
        fetchData={fetchConfig}
      />
    </Container>
  );
};

const selector = formValueSelector("fetchConfigs");
export default connect(state => ({
  selectedIssuer: selector(state, "scpIssuers"),
  config: state.getIssuerConfig,
  permissions: state.permissions && state.permissions.response,
  assignedIssuer:
    state.getIssuerDomainMapping &&
    state.getIssuerDomainMapping.response &&
    state.getIssuerDomainMapping.response.data
      ? state.getIssuerDomainMapping.response.data[0]
      : []
}))(ViewIssuerConfig);
